<div class="container-seo ">
  <div class="label">
    <div class="label-group">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 1025 1025"><path fill="#ea803f" d="m1014.86 967l-47 48q-10 9-24 9t-24-9l-151-152q-60 34-128 34q-106 0-181-75t-75-181t75-181t181-75t181 75t75 181q0 68-34 127l152 152q10 10 10 23.5t-10 23.5m-373.5-518q-79.5 0-136 56t-56.5 135.5t56.5 136t136 56.5t135.5-56.5t56-136t-56-135.5t-135.5-56m63.5-122v-6q0-27 19-45.5t45-18.5h128q27 0 46 18.5t19 45.5v320h-1q0-115-72.5-203.5T704.86 327m-320 122V193q0-27 19-45.5t45-18.5h128q27 0 45.5 18.5t18.5 45.5v128q-77 0-144 34.5t-112 93.5m0 383q45 60 112 94.5t144 34.5h64q0 26-18.5 45t-45.5 19h-576q-26 0-45-19t-19-45.5t18.5-45t45.5-18.5V64q0-26 19-45t45-19h128q27 0 45.5 19t18.5 45v833h64z"/></svg>
      <strong>SEO</strong>
    </div>
 
  </div>
    <div class="loading" *ngIf="loading">
      <div class="spinner-border" role="status"></div>
    </div>
    <table *ngIf="!loading" class="table table-bordered table-hover">
      <thead>
          <th scope="col" class="table-start col-md-2">{{'TAGS' | translate}}</th>
          <th scope="col" class="col-md-7">{{ 'METADATA' | translate }}</th>
          <th scope="col" class="table-end col-md-3">{{'ACTIONS' | translate}}</th>
      </thead>
      <tbody>
        <tr *ngFor="let field of seoFields">
          <td>{{ field.label }}</td>
          <td>
            <ng-container *ngIf="field.key === 'og:image'; else normalField">
              <div class="d-flex flex-column align-items-center">
                <img *ngIf="field.editing && (previewUrl || field.value)" [src]="previewUrl || field.value" alt="OG Image" class="seo-preview-img"/>
                <div *ngIf="field.editing; else readOnlyImage">
                  <input type="file" accept="image/*" class="form-control form-control-sm mb-2" (change)="onImageSelected($event)" />
                </div>
                <ng-template #readOnlyImage>
                  <div class="d-flex justify-content-between align-items-center gap-3 w-100">
                    <div class="d-flex align-items-center gap-2 flex-grow-1 overflow-hidden">
                      <span class="view-text text-truncate d-block seo-url-truncate" >
                        {{ field.value }}
                      </span>
                      <a *ngIf="!field.editing" class="copy-svg seo-copy-btn" (click)="copyToClipboard(field.value)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><g fill="none" stroke="#ea803f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M8 4v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.242a2 2 0 0 0-.602-1.43L16.083 2.57A2 2 0 0 0 14.685 2H10a2 2 0 0 0-2 2" /><path d="M16 18v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2" /></g></svg>
                      </a>
                    </div>
                    <img [src]="field.value" alt="OG Image" class="seo-thumbnail-img" />
                  </div>
                </ng-template>
              </div>
            </ng-container>
            <ng-template #normalField>
              <input *ngIf="field.editing" type="text" class="form-control form-control-sm" [(ngModel)]="field.value" />
              <span *ngIf="!field.editing" class="view-text">{{ field.value }}</span>
            </ng-template>
          </td>
          
          <td>
            <div class="edit-actions" *ngIf="field.editing">
              <button class="primary-btn btn-sm" (click)="saveField(field)">{{ "SAVE" | translate }}</button>
              <button class="remove-btn btn-sm" (click)="cancelEdit(field)">{{ "CANCEL" | translate }}</button>
            </div>
            <div *ngIf="!field.editing">
              <button class="primary-btn btn-sm" (click)="toggleEdit(field)">{{ "EDIT" | translate }}</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="showToast" class="toast show position-fixed bottom-0 end-0 m-3 text-white" role="alert">
      <div class="toast-body">
        {{ "COPIED" | translate }}
      </div>
    </div>
</div>

<div class="modal seo-confirm-modal" id="successSeoModal" tabindex="-1">
  <div class="modal-dialog seo-modal-dialog" role="document">
    <div class="modal-content seo-modal-content">
      <div class="modal-body seo-modal-body">
        <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
        <p class="text-center">{{ 'SEO_SAVED_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal seo-confirm-modal fade" id="errorSeoModal" tabindex="-1">
  <div class="modal-dialog seo-modal-dialog" role="document">
    <div class="modal-content seo-modal-content">
      <div class="modal-body seo-modal-body">
        <h3 class="text-center">{{'ERROR' | translate}}</h3>
        <p class="text-center">{{'ERROR_SAVING_CHANGES' | translate}}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
      </div>
    </div>
  </div>
</div>
